export default __webpack_public_path__ + "static/relaxation-05829969aff8af8a1e6aca5b7c750437.jpg";